export default {
  title01: "වත්මන් කාලගුණය",
  title02: "පැය 24",
  title03: "දින 10 කාලගුණ අනාවැකිය බලන්න",
  title04: "AQI",
  title05: "සියලු තොරතුරු බලන්න",
  title06: "හිරු උදාව සහ හිරු බැස යෑම",
  title07: "සඳේ අදියර",
  title08: "ඊළඟ පූර්ණ චන්ද්රයා",
  title09: "ඊළඟ නව සඳ",
  title10: "දිනය",
  title11: "රාත්‍රිය",
  title12: "ඉර උදාව",
  title13: "ඉර බැසීම",
  title14: "සඳ උදාව",
  title15: "සඳ බැස යාම",
  title16: "මූලාශ්රය",
  title17: "ආරම්භය",
  title18: "අවසානය",
  title19: "වත්මන් ස්ථානය භාවිතා කරන්න",
  title20: "නගරය සොයන්න",
  title21: "දැනෙනවා වගේ",
  title22: "සෙවණක් සේ දැනේ",
  title23: "දැන්",
  title24: "අද",
  title25: "SUN",
  title26: "MON",
  title27: "TUE",
  title28: "WED",
  title29: "THU",
  title30: "FRI",
  title31: "SAT",
  title32: "පූරණය වෙමින්...",
  title33: "දැන්",
  title34: "පැයෙන් පැයට",
  title35: "දිනපතා",
  title36: "ඉරයි හඳයි",
  title37: "වාතයේ ගුණාත්මකභාවය",
  title38: "සම්බන්ධ වන්න : xlf550402@gmail.com",
  title39: "පෞද්ගලිකත්ව ගිවිසුම",
  title40: "ප්‍රකාශන හිමිකම © comfortWeather.com 2020 - 2024. සියලුම හිමිකම් ඇවිරිණි.",
  title41: "දත්ත සපයන ලද්දේ",
  title42: "ආයුබෝවන්",
  title43: "ලෝ",
  title44: "පිළිගන්න",
  title45:
    "ComfortWeather භාවිතා කිරීම ගැන ඔබට ස්තුතියි! ඔබේ නෛතික අයිතිවාසිකම් සහ රුචිකත්වයන් වඩා හොඳින් ආරක්ෂා කර ගැනීමට, කරුණාකර ",
  title46: "පෞද්ගලිකත්ව ප්‍රතිපත්තිය",
  title47: " භාවිතා කිරීමට පෙර ප්‍රවේශමෙන් කියවන්න.",
  title48: "",

  title49: "සම්බන්ධ වන්න : xyjph123@gmail.com",
  title50: "ප්‍රකාශන හිමිකම © 24hweather.com 2020 - 2024. සියලුම හිමිකම් ඇවිරිණි.",
  title51:
    "24hweather භාවිතා කිරීම ගැන ඔබට ස්තුතියි! ඔබේ නෛතික අයිතිවාසිකම් සහ රුචිකත්වයන් වඩා හොඳින් ආරක්ෂා කර ගැනීමට, කරුණාකර ",
};
